import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-loan-select',
    templateUrl: './loan-select.component.html',
    styleUrl: './loan-select.component.scss',
    standalone: false
})
export class LoanSelectComponent {
    @Input() label: string = '';
    @Input() options: string[] = [];
    @Input() values: string[] = [];
    // @Input() required: boolean = true;
    @Input() control!: FormControl;

    get isRequired(): boolean {
        return this.control.hasValidator(Validators.required);
    }
}
